import Router from './util/router';
import CommonRoute from './routes/common';
import FindRetailerRoute from './routes/find-retailer';
import RetailersRoute from './routes/retailers';
import SingleProductsRoute from './routes/single-products';
import SingleAccessoriesRoute from './routes/single-accessories';
import ArchiveAccessoriesRoute from './routes/archive-accessories';

const $ = jQuery;

const routes = {
  common: CommonRoute,
  page_template_find_retailer: FindRetailerRoute,
  page_template_retailers: RetailersRoute,
  single_products: SingleProductsRoute,
  single_accessories: SingleAccessoriesRoute,
  post_type_archive_accessories: ArchiveAccessoriesRoute,
};

// Load Events
$(document).ready(() => new Router(routes).loadEvents());
